/**
 * @file 工具类函数
 * @author hardylin <hardylin@tencent.com>
 */

/**
 * 获取指定名称的 url 参数
 * @param {String} name - 参数名称
 * @param {String} url - 指定 url，不指定默认为当前页面 url
 * @returns {String} - 参数的值，未找到则返回 null
 */
export function getUrlParam(name, url) {
    const reg = new RegExp('(\\?|&)' + name + '=([^&#]*)')
    const result = reg.exec(url ? url : location.href)
    return result != null ? decodeURIComponent(result[2]) : null
}

/**
 * 动态加载 script 脚本
 * @param {String} url - 要加载的脚本 url
 * @returns {Object} - Promise 对象
 */
export function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.onload = resolve
        script.onerror = reject
        script.src = url
        document.body.appendChild(script)
    })
}

/**
 * 防抖方法
 * @param {Function} fn - 执行函数
 * @param {Number} delay - 防抖间隔，单位：ms
 */
export function debounce(fn, delay) {
    // 定时器，用来 setTimeout
    let timer

    // 返回一个函数，这个函数会在一个时间区间结束后的 delay 毫秒时执行 fn 函数
    return function () {
        // 保存函数调用时的上下文和参数，传递给 fn
        const context = this
        const args = arguments

        // 每次这个返回的函数被调用，就清除定时器，以保证不执行 fn
        clearTimeout(timer)

        // 当返回的函数被最后一次调用后（也就是用户停止了某个连续的操作），
        // 再过 delay 毫秒就执行 fn
        timer = setTimeout(function () {
            fn.apply(context, args)
        }, delay)
    }
};

/**
 * 节流方法
 * @param {Function} fn - 执行函数
 * @param {Number} delay - 节流间隔，单位：ms
 */
export function throttle (fn, delay) {
    let args     = arguments,
        context  = this,
        timer    = null,
        remaining   = 0,
        previous = new Date();

    return function () {
        let now = new Date();
        remaining = now - previous;

        if (remaining >= delay) {
            if (timer) {
                clearTimeout(timer);
            }

            fn.apply(context, args);
            previous = now;
        } else {
            if (!timer) {
                timer = setTimeout(function () {
                    fn.apply(context, args);
                    previous = new Date();
                }, delay - remaining);
            }
        }
    }
}

/**
 * 获取指定名称的 url 参数
 * @param {String} name - 参数名称
 * @param {String} url - 指定 url，不指定默认为当前页面 url
 * @returns {String} - 参数的值，未找到则返回 null
 */
export function mGetUrlParam(name, url) {
    const reg = new RegExp('(\\?|&)' + name + '=([^&#]*)', 'i')
    const result = reg.exec(url ? url : location.href)
    return result != null ? decodeURIComponent(result[2]) : ''
}
